<template>
    <b-modal
      v-model="isModalOpen"
      size="lg"
      @hidden="emitAction('close')"
      hide-header
      hide-footer
    >
       <div class="custom-modal-header d-flex justify-content-between align-items-center" style="padding: 20px">
        <h5 class="modal-title font-16">{{ modalData.jd.company }}</h5>
        <button 
          type="button" 
          class="close" 
          @click="emitAction('close')"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="jd-details" style="">
        <div class="jd-section jd-title-section">
          <h3>{{ modalData.jd.job_title }}</h3>
        </div>
  
        <div class="jd-section jd-info-section">
          <div v-html="modalData.jd.job_description"></div>
        </div>
      </div>
  
      <div class="custom-modal-footer" v-if="!modalData.isReplied">
        <div class="btn-container d-flex flex-wrap justify-content-center w-100" style="gap: 5px;">
          <b-button 
              class="custom-btn"
              style="background-color: #6C757D;"
              @click="emitAction('refrain')"
          >今回は控える</b-button>

          <b-button 
              v-if="modalData.isQuestion"
              class="custom-btn question-btn"
              style="background-color: #6C757D;"
              @click="emitAction('question')"
          >質問する</b-button>

          <b-button 
              variant="secondary" 
              class="custom-btn"
              style="background-color: #006C6B;"
              @click="emitAction('submit')"
          >{{ modalData.buttonText }}</b-button>
        </div>
      </div>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: 'IndividualJDModal',
    
    props: {
      modalData: {
          type: Object,
          required: true
      },
      // jd: {
      //   type: Object,
      //   required: true,
      // },
      // isOpen: {
      //   type: Boolean,
      //   default: false
      // },
      // buttonText: {
      //   type: String,
      //   required: true
      // },
      // isReplied: {
      //   type: Boolean,
      //   default: false
      // },
      // isQuestion: {
      //   type: Boolean,
      //   default: false
      // }
    },
  
    computed: {
      isModalOpen: {
          get() {
              return this.modalData.isOpen
          },
          set(value) {
              if (!value) {
                  this.emitAction('close')
              }
          }
      }
    },
    methods: {
      emitAction(action) {
        console.log(action);
          this.$emit('modal-action', action);
      },
    }
  }
  </script>
  
  <style scoped>
  ::v-deep .modal {
    padding-left:0px !important;
  }
  ::v-deep .modal-body {
      padding: 0px !important;
  }
  .question-btn {
    background-color: #2F80ED !important;
    border-color: #2F80ED;
  }
  .font-16 {
      font-size: 16px;
  }
  .jd-section {
      text-align: left;
      padding: 30px 50px;
  }
  
  .jd-title-section {
      background: #ededed;
      height: 76px;
      padding: 30px 20px;
  }
  
  .jd-info-section {
      max-height: 400px;
      overflow-y: auto;
      padding: 20px;
  }
  
  .jd-info-section p {
      font-size: 16px;
  }
  
  .jd-section h3 {
    margin: 0;
    color: #2c3e50;
    font-size: 16px;
  }
  
  .company {
    color: #666;
    font-size: 1.1rem;
    margin: 0.5rem 0;
  }
  
  .custom-modal-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 2rem;
    background-color: #F2F5F7;
    border-top: 1px solid #dee2e6;
  }
  
  .custom-btn {
    border-radius: 0 !important;  /* Makes buttons rectangular */
    min-width: 160px;  /* Optional: ensures consistent button width */
    height: 60px;
    padding: 2px;
    border-radius: 1px !important;
  }
  
  .custom-btn:disabled {
      opacity: 1;
  }

  @media (max-width: 768px) {
    .custom-modal-footer{
      justify-content: space-between;
      padding: 0.75rem;
    }
    .custom-btn {
      min-width: 125px;
      height: 40px;
      border-radius: 4px !important;
      font-size: 11px;
      font-weight: bold;
    }
    .jd-title-section {
      padding: 10px 20px;
    }
  }
  
  </style>
  